export default {
  isLoading: false,
  selectedOption: {
    icon: null, name: "12 meses anteriores", value: 12,
  },
  range: "12",
};

